import apiClient from '../../../Services/ApiClient';
import { TERM_ITEMS } from '../termItems.graphql';
import { SelectValue } from '../../../Components/Base/Select/Select';
import { TermItem } from '../../../graphql/graphql';

// @ts-ignore
export const getTermsByType = async termType => {
	const variables = {
		termType: termType,
	};
	const { meta, data } = await apiClient.graphql({
		query: TERM_ITEMS,
		variables,
		fetchPolicy: 'network-only',
	});

	return data;
};

type TermItemFields = 'id' | 'name' | 'value' | 'value2' | 'value3';

export const modifyTermItemsAsSelectValues = ({
	data,
	valueKey,
	labelKey,
}: {
	data: TermItem[];
	valueKey?: TermItemFields;
	labelKey?: TermItemFields;
}): SelectValue[] => {
	const items: SelectValue[] = [];

	for (const termItem of data || []) {
		if (termItem) {
			items.push({
				value: (valueKey ? termItem[valueKey] : termItem.id) || termItem.id,
				label: (labelKey ? termItem[labelKey] : termItem.name) || termItem.id,
			});
		}
	}

	return items;
};
